export const generateRoundNames = (nb) => {
  const power = Math.ceil(Math.log2(nb));
  const noms = [];
  for (let i = power; i >= 1; i--) {
    if (i === 1) noms.push("Finale");
    else if (i === 2) noms.push("1/2 finale");
    else if (i === 3) noms.push("1/4 finale");
    else if (i === 4) noms.push("1/8 finale");
    else if (i === 5) noms.push("1/16 finale");
    else noms.push(`1/${Math.pow(2, i)} finale`);
  }
  return noms;
};

export const getRoundName = (nbCompetiteurs) => {
  const map = {
    2: "Finale",
    4: "1/2 finale",
    8: "1/4 finale",
    16: "1/8 finale",
    32: "1/16 finale",
  };
  return map[nbCompetiteurs] || `Tour à ${nbCompetiteurs}`;
};
